import { Box, Button, Typography, Stack, useTheme } from '@mui/material';
import { useAuth, AuthResponseCode } from '@dwelvio/auth-react';
import GoogleIcon from '../../components/google-icon';

import { useNavigate, useSearchParams } from 'react-router';
import { SignInForm } from './components/signin-form';
import { appPaths } from '../../app-paths';
import { IUserData } from '../../types';
import { LogoWithText } from '../../components/logo-with-text';

export function SignInPage() {
  const { login, error } = useAuth<IUserData>();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const theme = useTheme();

  const accountId = params.get('a') || undefined;
  const refUrl = params.get('refUrl') || undefined; //window.location.pathname;
  const username = params.get('username') || undefined;
  const signupSuccess = params.get('signup') === '1';

  return (
    <Box
      maxWidth="400px"
      minWidth="300px"
      sx={{ mx: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      <Box
        component="header"
        sx={{ mx: 'auto', py: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <LogoWithText color={theme.palette.primary.main} textColor={theme.palette.secondary.dark} height={50} />
      </Box>
      <Box component="main" sx={{ mx: 'auto', py: 3, px: 2 }}>
        {/* <Stack gap={4} sx={{ mb: 2 }}>
          <Typography variant="h4">Prihlásenie</Typography>
          <Button fullWidth variant="contained" startIcon={<GoogleIcon />}>
            Prihlásenie cez Google
          </Button>
        </Stack>
        <Divider>alebo</Divider> */}
        {signupSuccess && (
          <Stack gap={3} sx={{ textAlign: 'center' }}>
            <Typography variant="h4" color="success.main">
              ✓ E-mail overený
            </Typography>
            <Typography variant="body1">Váš e-mail bol úspešne overený. Teraz sa môžete prihlásiť.</Typography>
          </Stack>
        )}
        <Stack gap={1} sx={{ mt: 2 }}>
          <SignInForm
            username={username || undefined}
            onSignin={async (username: string, password: string) => {
              let result: AuthResponseCode = 'server_error';
              try {
                result = await login({ username, password, accountId });
              } catch (e: any) {
                // login function should not throw, but just in case
              }

              return result;
            }}
            onSuccess={() => {
              if (refUrl) {
                navigate(refUrl);
              } else {
                navigate(appPaths.unitList.navigate());
              }
            }}
          />

          <Typography variant="body2" textAlign="center">
            Ešte nemáte účet?{' '}
            <Button variant="text" onClick={() => navigate(appPaths.signup.navigate(refUrl))}>
              Registrovať sa
            </Button>
          </Typography>
          <Typography variant="body2" textAlign="center">
            Zabudli ste heslo?{' '}
            <Button variant="text" onClick={() => navigate(appPaths.passwordForgot.navigate())}>
              Požiadať o obnovenie hesla
            </Button>
          </Typography>
        </Stack>
      </Box>
      <Box component="footer" sx={{ py: 3 }}>
        <Typography variant="body2" textAlign="center">
          © dwelvio.com {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
}
